<div class="search-shell" [class.search-active]="searchPerformed" [class.has-note]="matchNote">
  <input class="form-control search-input"
    #searchInput
    type="text"
    placeholder="Search Document"
    aria-label="Search Document"
    [(ngModel)]="searchText"
    (ngModelChange)="handleTextChange($event)"
    [disabled]="disabled"
    (keydown.enter)="onEnter($event)">

  <div class="search-actions">
    <button class="icon-btn search-btn"
      tabindex="-1"
      [class.loading]="isWaiting || searchLoading"
      [disabled]="disabled"
      (click)="submit(); searchInput.focus()">
      @if (isWaiting || searchLoading) {
        <div class="loader search-loading-spinner"></div>
      } @else {
        <i class="fas fa-magnifying-glass"></i>
      }
    </button>

    @if (searchPerformed) {
      <div class="result-controls">
        <span class="search-count">{{currentMatchNumber}} / {{totalMatches}}@if (matchNote) { — {{matchNote}}}</span>
        <button class="icon-btn" tabindex="-1" (click)="prev(); searchInput.focus()" [disabled]="searchLoading || !totalMatches">
          <i class="fas fa-angle-up"></i>
        </button>
        <button class="icon-btn" tabindex="-1" (click)="next(); searchInput.focus()" [disabled]="searchLoading || !totalMatches">
          <i class="fas fa-angle-down"></i>
        </button>
        <button class="icon-btn" tabindex="-1" (click)="clear(); searchInput.focus()">
          <i class="fas fa-xmark"></i>
        </button>
      </div>
    }
    @if (searchText && !searchPerformed) {
      <button class="icon-btn"
        tabindex="-1"
        (click)="clear(); searchInput.focus()"
        title="Clear search">
        <i class="fas fa-xmark"></i>
      </button>
    }
  </div>
</div>
@if (searchError) {
  <div class="search-error text-danger">{{searchError}}</div>
}